import { StateSchema } from 'app/config/storeConfig/types';

export const getContractId = (state: StateSchema): Nullable<string> => state.contractDetailsDrawer.contractId;
